import React, { useState, useContext, useRef } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";
import moment from "moment/moment";
import { useReactToPrint } from "react-to-print";
import { Sellitemprint } from "../sell/sellitemprint";

const Customer_invoice_item_ledger_modal = (props) => {

    const printRef = useRef();
        
    const printFn = useReactToPrint({
        contentRef: printRef,
        documentTitle: "loanback",
        preserveAfterPrint: true,
        print: (printIframe) =>
        new Promise(() => {
            printIframe.style.display = "none";

            printIframe.contentWindow?.print();
        }),
    });
    return (
        <>
            {props.show ? (
            <>
                <div
                    style={{
                    position: 'absolute',
                    left: '-99999px',
                    top: 0
                    }}
                >
                    <Sellitemprint ref={printRef} invoiceno={props?.invoice_detail?.sell_invoice_id} sell_invoice_type={props?.invoice_detail?.sell_invoice_type} loan_back_amount={props?.invoice_detail?.sell_invoice_loan_in_amount} remained_loan={props?.invoice_detail?.customer_loan} sell_invoice_discount={props?.invoice_detail?.sell_invoice_discount} sell_invoice_dollar_price={props?.invoice_detail?.sell_invoice_dollar_price} customer_name={props?.invoice_detail?.sell_invoice_customer_name} customer_address={props?.invoice_detail?.sell_invoice_customer_address} customer_phone={props?.invoice_detail?.sell_invoice_customer_phone} sell_invoice_date={props?.invoice_detail?.sell_invoice_date} items={props?.invoice_detail?.items} />
                </div>
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative  my-6 mx-auto w-11/12 sm:w-5/6 md:w-2/3 lg:w-5/6">
                    {/*content*/}
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    {/*header*/}
                    <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                        <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                            وەسڵ
                        </h3>
                        <button
                        className="p-1 ml-auto bg-transparent border-0 text-black opacity-80 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                        onClick={() => props.setshow(false)}
                        >
                        <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                            X
                        </span>
                        </button>
                    </div>
                    {/*body*/}
                    <div className="relative p-4 sm:p-6 flex-auto max-h-[80vh] overflow-y-auto">
                        <div className="overflow-x-auto">
                        <table className="min-w-full leading-normal text-[10px] sm:text-xs md:text-sm">
                            <thead>
                                <tr>
                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    ناوی کاڵا - کۆد
                                </th>
                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    بڕی داواکراو
                                </th>
                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    نرخی دانە
                                </th>
                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    نرخی دانە (دینار)
                                </th>
                                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    کۆی نرخ
                                </th>
                                </tr>
                            </thead>
                            <tbody>
                                {props?.invoice_detail?.items?.map((lis, index) => (
                                <tr key={index}>
                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                    <div className="flex">
                                        <p className="text-gray-900 whitespace-no-wrap ml-1">
                                        {lis?.item_name}
                                        </p>
                                        <p className="text-gray-900 whitespace-no-wrap">
                                        -
                                        </p>
                                        <p className="text-gray-900 whitespace-no-wrap mr-1">
                                        {lis?.item_barcode}
                                        </p>
                                    </div>
                                    </td>
                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                        {/* {lis?.item_unit_one} {Math.floor(lis?.item_qty)}/{Math.round((Number(lis?.item_qty)-Number(Math.floor(lis?.item_qty)))*lis?.item_unit_one_of_many)} {lis?.item_unit_many} */}
                                        {lis.item_unit_one} {Math.floor(lis.item_qty/lis.item_unit_one_of_many)}/{money_rounding(Number(lis.item_qty) % lis.item_unit_one_of_many)} {lis.item_unit_many}
                                    </td>
                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                        {numberbeautify(lis?.item_sell_price)} $
                                    </td>
                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                        {numberbeautify(money_rounding(Number(lis?.item_sell_price)*Number(props?.invoice_detail?.sell_invoice_dollar_price)))}
                                    </td>
                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                        {numberbeautify(money_rounding(
                                            Number(lis?.item_sell_price) * Number(lis?.item_qty)
                                        ))} $
                                    </td>
                                    
                                </tr>
                                ))}
                                <tr>
                                <th
                                    className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                    colSpan={4}
                                >
                                    کۆی نرخ
                                </th>
                                <td 
                                    className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center"
                                    colSpan={3}
                                >
                                    {numberbeautify(
                                    props?.invoice_detail?.items?.reduce(
                                        (a, v) =>
                                        (a =
                                            Number(a) +
                                            (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * Number(v.item_qty)):0)),
                                        0
                                    )
                                    )} $
                                </td>
                                </tr>
                                {props?.invoice_detail?.sell_invoice_discount>0&&(
                                <tr>
                                <th
                                    className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                    colSpan={4}
                                >
                                    داشکاندن
                                </th>
                                <td 
                                    className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center"
                                    colSpan={3}
                                >
                                    {numberbeautify(money_rounding(
                                    Number(props?.invoice_detail?.items?.reduce(
                                        (a, v) =>
                                        (a =
                                            Number(a) +
                                            (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * Number(v.item_qty)):0)),
                                        0
                                    ))*Number(props?.invoice_detail?.sell_invoice_discount/100)
                                    )
                                    )} $
                                </td>
                                </tr>)}
                                <tr>
                                <th
                                    className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                    colSpan={4}
                                >
                                    کۆی گشتی
                                </th>
                                <td 
                                    className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center"
                                    colSpan={3}
                                >
                                    {numberbeautify(money_rounding(
                                    Number(props?.invoice_detail?.items.reduce(
                                        (a, v) =>
                                        (a =
                                            Number(a) +
                                            (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * Number(v.item_qty)):0)),
                                        0
                                    ))*Number(1-props?.invoice_detail?.sell_invoice_discount/100)
                                    )
                                    )} $
                                </td>
                                </tr>
                                <tr>
                                <th
                                    className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                    colSpan={4}
                                >
                                    کۆی گشتی - دینار
                                </th>
                                <td 
                                    className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center"
                                    colSpan={3}
                                >
                                    {numberbeautify(iqd_rounding((money_rounding(
                                    Number(props?.invoice_detail?.items.reduce(
                                        (a, v) =>
                                        (a =
                                            Number(a) +
                                            (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * Number(v.item_qty)):0)),
                                        0
                                    ))*Number(1-props?.invoice_detail?.sell_invoice_discount/100)
                                    ))*Number(props?.invoice_detail?.sell_invoice_dollar_price))
                                    )} IQD
                                </td>
                                </tr>
                                {props?.invoice_detail?.sell_invoice_type=="loan"&&(
                                    <tr>
                                    <th
                                        className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                        colSpan={4}
                                    >
                                        کۆی ماوە
                                    </th>
                                    <td 
                                        className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center"
                                        colSpan={3}
                                    >
                                        {numberbeautify(money_rounding(
                                        Number(props?.invoice_detail?.items?.reduce(
                                            (a, v) =>
                                            (a =
                                                Number(a) +
                                                (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * Number(v.item_qty)):0)),
                                            0
                                        ))*Number(1-props?.invoice_detail?.sell_invoice_discount/100)-Number(props?.invoice_detail?.sell_invoice_loan_in_amount)
                                        )
                                        )} $
                                    </td>
                                    </tr>
                                )}
                                {props?.invoice_detail?.sell_invoice_type=="loan"&&(
                                    <tr>
                                    <th
                                        className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                        colSpan={4}
                                    >
                                        کۆی ماوە - دینار
                                    </th>
                                    <td 
                                        className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center"
                                        colSpan={3}
                                    >
                                        {numberbeautify(iqd_rounding((money_rounding(
                                        Number(props?.invoice_detail?.items?.reduce(
                                            (a, v) =>
                                            (a =
                                                Number(a) +
                                                (v.item_sell_state=="pay"?money_rounding(Number(v.item_sell_price) * Number(v.item_qty)):0)),
                                            0
                                        ))*Number(1-props?.invoice_detail?.sell_invoice_discount/100)-Number(props?.invoice_detail?.sell_invoice_loan_in_amount)
                                        ))*Number(props?.invoice_detail?.sell_invoice_dollar_price))
                                        )} IQD
                                    </td>
                                    </tr>
                                )}
                            </tbody>
                            </table>
                        </div>
                    </div>
                    {/*footer*/}
                    <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                        <button
                            className="bg-slate-600 text-white active:bg-slate-800 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                            type="button"
                            onClick={() => {
                                setTimeout(() => {
                                    printFn();
                                }, 500);
                            }}
                        >
                            پرینت
                        </button>
                    </div>
                    </div>
                </div>
                </div>
                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
            ) : null}
        </>
    )
}

export default Customer_invoice_item_ledger_modal